import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] text-center mb-12" data-id="element-11">
          ¿Es Este Plan Para Ti?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-12">
          {/* For Section */}
          <motion.div {...fadeInUp} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-green-50 border-2 border-green-200 rounded-2xl p-6 md:p-8" data-id="element-13">
            <h3 className="text-xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-14">
              <CheckCircleIcon className="w-6 h-6" data-id="element-15" />
              Para Quién ES Este Plan
            </h3>

            <div className="space-y-4" data-id="element-16">
              <div className="flex items-start gap-3" data-id="element-17">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-18" />
                <p className="text-gray-700" data-id="element-19">
                  Inquilinos en EE.UU. cansados de los aumentos de renta
                  anuales.
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-20">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-21" />
                <p className="text-gray-700" data-id="element-22">
                  Familias que tienen un trabajo estable pero les cuesta ahorrar
                  miles de dólares.
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-23">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-24" />
                <p className="text-gray-700" data-id="element-25">
                  Personas con crédito "promedio" (620+) que creen que no
                  califican.
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-26">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-27" />
                <p className="text-gray-700" data-id="element-28">
                  Padres que quieren dejar un legado y estabilidad real para sus
                  hijos.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Not For Section */}
          <motion.div {...fadeInUp} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 md:p-8" data-id="element-29">
            <h3 className="text-xl font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-30">
              <XCircleIcon className="w-6 h-6" data-id="element-31" />
              Para Quién NO Es
            </h3>

            <div className="space-y-4" data-id="element-32">
              <div className="flex items-start gap-3" data-id="element-33">
                <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-34" />
                <p className="text-gray-700" data-id="element-35">
                  Personas que no tienen un ingreso comprobable o historial de
                  trabajo.
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-36">
                <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-37" />
                <p className="text-gray-700" data-id="element-38">
                  Inversionistas que buscan comprar edificios comerciales o
                  complejos grandes.
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-39">
                <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-40" />
                <p className="text-gray-700" data-id="element-41">
                  Gente que espera que la casa le caiga del cielo sin seguir un
                  plan de pasos claro.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}